import { getDatabase, ref, get } from 'firebase/database';

export interface InventorySession {
    uid: string;
    startTime: string;
    endTime: string | null;
}

export interface InventorySessionsData {
    [buildingKey: string]: {
        [sessionId: string]: InventorySession;
    };
}

class InventorySessionsApi {
    private db = getDatabase();

    /**
     * Fetch all inventory sessions from debug/inventorySessions
     */
    async getAllSessions(): Promise<InventorySessionsData> {
        const sessionsRef = ref(this.db, 'debug/inventorySessions');
        const snapshot = await get(sessionsRef);

        if (!snapshot.exists()) {
            return {};
        }

        return snapshot.val() as InventorySessionsData;
    }
}

export const inventorySessionsApi = new InventorySessionsApi();
